import { Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { routes } from "./routes/route";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { RootState } from "./redux/store";
import { logoutOwner } from "./redux/ownerSlice";
import { refreshAccessTokenOwner } from "./utils/auth/refreshOwnerToken";
import { useEffect } from "react";
import { refreshAccessTokenStore } from "./utils/auth/refreshStoreToekn";
import { logoutStore } from "./redux/storeSlice";
import { v4 as uuidv4 } from 'uuid'; 
import { refreshAccessTokenAdmin } from "./utils/auth/refreshAdminToken";

const queryClient = new QueryClient();

function App() {
  const dispatch = useDispatch();
  const { refreshToken: ownerRefreshToken } = useSelector((state: RootState) => state.owner);
  const { refreshToken: storeRefreshToken } = useSelector((state: RootState) => state.store);
  const { refreshToken: adminRefreshToken } = useSelector((state: RootState) => state.admin);

    useEffect(() => {
      const checkAndRefreshToken = async () => {
        console.log('Checking and refreshing tokens...');

        const lastRefresh = localStorage.getItem('lastTokenRefresh');
        const twelveHoursInMs = 6 * 60 * 60 * 1000;
        const now = Date.now();

        // Only refresh if more than 6 hours have passed
        if (!lastRefresh || now - parseInt(lastRefresh) >= twelveHoursInMs) {


          if (ownerRefreshToken) {
            const newAccessToken = await refreshAccessTokenOwner();
            if (!newAccessToken) {
              dispatch(logoutOwner());
            }
          }

          if (storeRefreshToken) {
            const newAccessToken = await refreshAccessTokenStore();
            if (!newAccessToken) {
              dispatch(logoutStore());
            }
          }

          if (adminRefreshToken) {
            const newAccessToken = await refreshAccessTokenAdmin();
            if (!newAccessToken) {
              dispatch(logoutStore());
            }
          }

          // Save the current time as the last refresh
          localStorage.setItem('lastTokenRefresh', now.toString());
        }
      };

      checkAndRefreshToken();

      // Optional: run periodically in case the user stays on the page long enough
      const intervalId = setInterval(checkAndRefreshToken, 60 * 60 * 1000); // check every hour

      return () => {
        clearInterval(intervalId);
      };
    }, [ownerRefreshToken, storeRefreshToken, dispatch,adminRefreshToken]);

    // Create a UUID on first load if none exists
useEffect(() => {
  const key = 'uuid';          // you can name the key anything
  if (!localStorage.getItem(key)) {
    const newId = uuidv4();
    localStorage.setItem(key, newId);
  }
}, []);




  return (
    <QueryClientProvider client={queryClient}>
      <>
        <ToastContainer position="bottom-right" />
        <Routes>
          {routes.map(({ path, element }, index) => (
            <Route
              key={index}
              path={path}
              element={
                element
              }
            />
          ))}
        </Routes>
      </>
    </QueryClientProvider>
  );
}

export default App;
